// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"1a827617","164":"0bb48768","521":"634e070b","563":"843f8c4c","869":"6c17b8c5"}[chunkId] + ".chunk.js";
};